import React from 'react';
import { FileText, Plus, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Policies = () => {
  return (
    <div className="bg-white">
      {/* Page Header */}
      <div className="page-header">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="page-header-title">Policies</h1>
            <p className="page-header-subtitle">Manage insurance policies and renewals</p>
          </div>
          <Link
            to="/clients"
            className="btn btn-primary mt-4 sm:mt-0"
          >
            <Plus className="h-4 w-4 mr-2" />
            Add Policy
          </Link>
        </div>
      </div>

      {/* Content Area */}
      <div className="px-6 py-12 sm:px-8">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-8">
            <FileText className="h-12 w-12 text-gray-400 mx-auto mb-4" />
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">Policy Management</h2>
            <p className="text-gray-600 mb-6">
              Policy information is currently managed through the Clients section.
            </p>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6">
            <h3 className="font-semibold text-blue-900 mb-2">Current Workflow</h3>
            <p className="text-blue-800 text-sm mb-4">
              Each client record contains associated policy details including policy type, premium amount, and renewal dates. You can view and manage all policies through the Clients section.
            </p>
            <Link
              to="/clients"
              className="text-blue-600 hover:text-blue-700 font-medium inline-flex items-center text-sm"
            >
              Go to Clients
              <ArrowRight className="h-4 w-4 ml-2" />
            </Link>
          </div>

          <div className="border border-gray-200 rounded-lg p-6 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-3">Quick Stats</h3>
            <p className="text-gray-600 text-sm">
              For a complete overview of all policies and their status, visit the Clients section where you can filter by policy status.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Policies;
